import React, { useEffect, useState } from "react";

const screens = [
  {
    alt: "priseen-business-splash-screen",
    src: "assets/images/hero-images/priseen-business-splash-screen-r.png",
    id: "priseen-business-splash-screen",
  },
  {
    alt: "priseen-customer-splash-screen",
    src: "assets/images/hero-images/priseen-splash-screen-r.png",
    id: "priseen-customer-splash-screen",
  },
];

const customAnimations = `
  @keyframes fadeInLeft {
    from { opacity: 0; transform: translateX(-20px); }
    to { opacity: 1; transform: translateX(0); }
  }

  @keyframes fadeOutLeft {
    from { opacity: 1; transform: translateX(0); }
    to { opacity: 0; transform: translateX(-20px); }
  }

  @keyframes fadeInRight {
    from { opacity: 0; transform: translateX(20px); }
    to { opacity: 1; transform: translateX(0); }
  }

  @keyframes fadeOutRight {
    from { opacity: 1; transform: translateX(0); }
    to { opacity: 0; transform: translateX(20px); }
  }
`;
export default function HeroPhone() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % screens.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="relative h-[250px] w-[200px] md:w-full lg:w-full">
      <img
        src={"assets/images/hero-images/phone-frame.png"}
        alt={"phone-frame"}
        className="absolute top-0 lef-0 w-full  object-contain transition-all duration-1000 transform hover:scale-105 z-[1]"
      />
      {screens.map(({ src, alt, id }, index) => {
        return (
          <div
            key={id}
            className={`absolute w-full flex items-center justify-center transition-opacity duration-5000 ${
              index === activeIndex ? "opacity-100" : "opacity-0"
            }`}
          >
            <style>{customAnimations}</style>
            <img
              src={src}
              alt={alt}
              className={` w-full object-contain transition-all duration-1000 transform hover:scale-105 rounded-[60px] ${
                index === activeIndex
                  ? "animate-fadeInLeft"
                  : "animate-fadeOutLeft"
              }`}
            />
          </div>
        );
      })}
    </div>
  );
}
